import { createLucideIcon } from "lucide-react";

export const ChevronLeftCircle = createLucideIcon(
    "ChevronLeftCircle",
    [
        [
            "path",
            {
                d: "M13.5 16L10.725 12.3C10.5917 12.1222 10.5917 11.8778 10.725 11.7L13.5 8",
                key: "bzfeks",
            },
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                key: "1mglay",
                r: "10",
            },
        ],
    ],
);
